import { REGISTERED_MODULES } from "../modules/index.js";
import { composePacks } from "../modules/compose.js";
const BASE_PACKS = {
    CRM: {
        code: "CRM",
        label: "CRM",
        description: "Prospects, opportunités et activités commerciales",
        modules: ["crm-leads", "crm-opportunities", "crm-activities"],
        onboarding: [],
        terminology: {},
    },
    ACHATS: {
        code: "ACHATS",
        label: "Achats",
        description: "Fournisseurs, bons de commande et factures d'achat",
        modules: ["achats", "suppliers", "purchase-orders", "supplier-invoices"],
        onboarding: [],
        terminology: {},
    },
    IMPORT: {
        code: "IMPORT",
        label: "Importation",
        description: "Coûts de revient à l'import (landed cost)",
        modules: ["import-costs"],
        onboarding: [],
        terminology: {},
    },
    RH_PAIE: {
        code: "RH_PAIE",
        label: "RH & Paie",
        description: "Personnel, bulletins de paie et déclarations sociales",
        modules: ["hr"],
        onboarding: [],
        terminology: {},
    },
    PROJETS: {
        code: "PROJETS",
        label: "Projets",
        description: "Suivi de projets et planning",
        modules: ["projects"],
        onboarding: [],
        terminology: {},
    },
    BUDGET: {
        code: "BUDGET",
        label: "Budget",
        description: "Enveloppes budgétaires et engagements",
        modules: ["budget"],
        onboarding: [],
        terminology: {},
    },
    // Neither pack grants its enclosing group: `pos` sits in `ventes-caisse`
    // and `stock` in `catalogue`, both held by every profile. The two items
    // are `packOnly` in the navigation registry, which is what leaves the
    // pack something to add.
    CAISSE: {
        code: "CAISSE",
        label: "Caisse / point de vente",
        description: "Encaissement au comptoir et clôture de caisse",
        modules: ["pos"],
        onboarding: [],
        terminology: {},
    },
    STOCK: {
        code: "STOCK",
        label: "Stock & inventaire",
        description: "Mouvements de stock, inventaires et alertes de réapprovisionnement",
        modules: ["stock", "depots", "inventories"],
        onboarding: [],
        terminology: {},
    },
    MULTI_SITE: {
        code: "MULTI_SITE",
        label: "Multi-établissement",
        description: "Plusieurs sites, chacun avec sa numérotation et son MCF",
        modules: ["establishments"],
        onboarding: [],
        terminology: {},
    },
};
/**
 * Core's own packs plus those the capability modules bring. A pack is how a
 * module's transversal capability reaches sectors that are not its own.
 */
export const CAPABILITY_PACKS = composePacks(BASE_PACKS, REGISTERED_MODULES);
export function getCapabilityPack(code) {
    return CAPABILITY_PACKS[code] ?? null;
}
//# sourceMappingURL=packs.js.map